import {store} from '../store';
import i18n from '../i18n';
import {INTERSECT_TIME_ERROR_MESSAGE, UNIQUE_ERROR_MESSAGE,} from '../constants/translationLabels/validationMessages';
import { parseTime } from '../utils/dateUtils';

export const checkUniqClassName = (className, classes = [], currentClassId) => {
    let find = false;
    if (currentClassId) {
        find = classes.some(value => value.class_name === className && value.id !== currentClassId);
    } else {
        find = classes.some(value => value.class_name === className);
    }
    return find ? i18n.t(UNIQUE_ERROR_MESSAGE) : undefined;
};

const timeRangesOverlap = (start1, end1, start2, end2) => {
    return start1 < end2 && start2 < end1;
};

export const timeIntersectService = (startTime, endTime, classes = [], currentClassId) => {
    if (!startTime || !endTime) return undefined;

    const incomeStart = parseTime(startTime);
    const incomeEnd = parseTime(endTime);

    const find = classes.some((value) => {
        if (currentClassId && value.id === currentClassId) return false;
        return timeRangesOverlap(
            incomeStart,
            incomeEnd,
            parseTime(value.startTime),
            parseTime(value.endTime),
        );
    });

    return find ? i18n.t(INTERSECT_TIME_ERROR_MESSAGE) : undefined;
};

export const checkUniqueLesson = (lessons, currentLesson) => {
    if (!currentLesson?.id) {
        return !lessons.find(
            (lesson) =>
                lesson.subject.id === +currentLesson.subject.id &&
                lesson.teacher.id === +currentLesson.teacher.id &&
                lesson.lessonType === currentLesson.lessonType,
        );
    }
    return !lessons.find(
        (lesson) =>
            lesson.subject.id === +currentLesson.subject.id &&
            lesson.teacher.id === +currentLesson.teacher.id &&
            lesson.lessonType === currentLesson.lessonType &&
            lesson.id !== +currentLesson.id,
    );
};

export const checkUniqueGroup = (value, groups, currentId) => {
    const isDuplicate = groups.some(
        (group) => group.title.trim().toLowerCase() === value.trim().toLowerCase() && group.id !== currentId
    );
    return isDuplicate ? i18n.t(UNIQUE_ERROR_MESSAGE) : true;
};

export const checkUniqueSubject = (value, subjects, currentId) => {
    const isDuplicate = subjects.some(
        (subj) => subj.name.trim().toLowerCase() === value.trim().toLowerCase() && subj.id !== currentId
    );
    return isDuplicate ? i18n.t(UNIQUE_ERROR_MESSAGE) : true;
};

export const checkUniqueDepartment = (value, departments, currentId) => {
    const isDuplicate = departments.some(
        (dept) => dept.name.trim().toLowerCase() === value.trim().toLowerCase() && dept.id !== currentId
    );
    return isDuplicate ? i18n.t(UNIQUE_ERROR_MESSAGE) : true;
};

export const checkUniqSemester = (semester) => {
    const { semesters } = store.getState().semesters;
    let isNotUnique;
    if (!semester.id) {
        isNotUnique = !!semesters.find(
            (storeSemester) =>
                storeSemester.year === +semester.year &&
                storeSemester.description.toUpperCase().trim() ===
                    semester.description.toUpperCase().trim(),
        );
    } else {
        isNotUnique = !!semesters.find(
            (storeSemester) =>
                storeSemester.year === +semester.year &&
                storeSemester.description.toUpperCase().trim() ===
                    semester.description.toUpperCase().trim() &&
                storeSemester.id !== +semester.id,
        );
    }

    return !isNotUnique;
};
